import React, { useState, useContext } from "react";

const BoardSelectionContext = React.createContext();
const BoardSelectionUpdateContext = React.createContext();

export function useBoardSelection() {
  return useContext(BoardSelectionContext);
}

export function useBoardSelectionUpdate() {
  return useContext(BoardSelectionUpdateContext);
}

export function BoardSelectionProvider({ children }) {
  const [boardSelection, setBoardSelection] = useState([]);

  function updateBoardSelection(freshBoardSelectionArray) {
    setBoardSelection(freshBoardSelectionArray);
  }
  return (
    <BoardSelectionContext.Provider value={boardSelection}>
      <BoardSelectionUpdateContext.Provider value={updateBoardSelection}>
        {children}
      </BoardSelectionUpdateContext.Provider>
    </BoardSelectionContext.Provider>
  );
}
